import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { Link } from "components/CallToAction";

export const BecomeADealer = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query ApplicationsBecomeADealerHeroImageQuery {
          file(relativePath: { eq: "savantPowerVan.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 40% 50%;
              @media screen and (min-width: ${getSize(
                  "tablet720"
                )}) and (max-width: 959px) {
                object-position: 32% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 32px 38px 35px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 32px 46px 44px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 767px) {
          padding: 42px 46px 48px 50px;
          width: 377px;
        }
        @media screen and (min-width: ${getSize(
            "tablet768"
          )}) and (max-width: 959px) {
          width: 377px;
          padding: 41px 46px 46px 50px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 29px 36px 36px 37px;
          width: 373px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 44px 46px 46px 50px;
          width: 452px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 552px;
        }
      `}
    >
      <Header2
        css={`
          @media screen and (min-width: ${getSize("desktop1200")}) {
            font-size: 48px;
            line-height: 58px;
          }
        `}
      >
        {"Become a Dealer"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize(
                "default"
              )}) and (max-width: 479px) {
              margin-top: 14px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 21px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 1199px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize(
              "desktop1200"
            )}) and (max-width: 1919px) {
            font-size: 20px;
            line-height: 31px;
            margin-top: 20px;
          }
        `}
      >
        {
          "Consumers at all levels of the energy market feel these impacts and are taking on an increasingly active role in deciding the course of their energy future."
        }
      </Paragraph>
      <div
        css={`
          margin: 38px 0px 4px 0px;
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin: 29px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin: 36px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            margin: 38px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            margin: 20px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            margin: 23px 0px 4px 0px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin: 35px 0px 6px 0px;
          }
        `}
      >
        <Link to="/become-a-savant-power-dealer">{"Apply Here"}</Link>
      </div>
    </Card>
  </Section>
);
